import { RGedeeldePaginaPersoon } from '@cumlaude/service-contract';

export enum GedeeldePaginaPersoonMode {
	INBOX = 'inbox',
	OUTBOX = 'outbox',
}

export interface GedeeldePaginaPersoonGroep {
	type: GedeeldePaginaPersoonMode;
	naam: string;
	namen: string[];
	messageUUID: string;
	dashboard: string;
	hoofdpagina?: string;
	bericht?: string;
	berichtWeergave: string;
	verzonden: string;
	ongelezen?: boolean;
	primary: RGedeeldePaginaPersoon;
}

